import { combineReducers } from '@reduxjs/toolkit';
import tableReducer from './table';
import uiReducer from './ui';
import users from './user';
import eventReducer from './event';
import localReducer from './local';
import fiscalReducer from './fiscalyear';
import eventFilterReducer from '../../Pages/admin/Events/EventsTable/eventFilter';
import eventsReducer from './events';
import rostersReducer from './rosters';
import traineesReducer from './trainees';
import notificationReducer from './notification';
import defaultCertificateReducer from './defaultCertificate';
import CertificateReducer from './certificate';
import certificateWsReducer from './certificateWebsocket';
import defaultData from './defaultData';
import employeeLevelReducer from './employeelevel';

const rootReducer = combineReducers({
  ui: uiReducer,
  user: users,
  table: tableReducer,
  event: eventReducer,
  events: eventsReducer,
  rosters: rostersReducer,
  local: localReducer,
  eventFilter: eventFilterReducer,
  fiscalyear: fiscalReducer,
  trainees: traineesReducer,
  notification: notificationReducer,
  defaultCertificate: defaultCertificateReducer,
  certificateWs: certificateWsReducer,
  defaultData: defaultData,
  employeeLevel: employeeLevelReducer,
  certificate: CertificateReducer
});

export default rootReducer;
